import { setScheduleData } from '../../../shared/actions/flatTourBooking';
import { transformFlatTourBooking } from '../../../shared/mappers/transformFlatTourBooking';
import {
  fetchGetFlatTourBookingSchedule,
  IGetFlatTourBookingScheduleResponse200,
  IGetFlatTourBookingScheduleResponse400,
} from '../../../shared/repositories/newbuilding-flat-tour-booking/v1/get-flat-tour-booking-schedule';
import { canMakeFlatViewOrder } from '../../../shared/selectors';
import { getNewbuildingId } from '../../../shared/selectors/newObject';
import { IThunkActionCreator } from '../../../shared/store';
import { isValidFlatTourSchedule } from '../../../shared/utils/flatTourSchedule';

export function getFlatTourSchedule(): IThunkActionCreator {
  return async (dispatch, getState, { httpApi, logger }): Promise<void> => {
    try {
      const isTourEnabled = canMakeFlatViewOrder(getState());
      const newbuildingId = getNewbuildingId(getState());

      if (!isTourEnabled || !newbuildingId) {
        return;
      }

      const response = await fetchGetFlatTourBookingSchedule<
        IGetFlatTourBookingScheduleResponse200,
        IGetFlatTourBookingScheduleResponse400
      >({
        httpApi,
        parameters: { newbuildingId },
      });

      if (response.statusCode !== 200) {
        throw response.response.message;
      }

      if (!isValidFlatTourSchedule(response.response.schedule)) {
        throw new Error(`Ошибка валидации ISchedule в getFlatTourSchedule`);
      }

      const preparedData = transformFlatTourBooking(response.response.schedule);
      dispatch(setScheduleData(preparedData));
    } catch (error) {
      logger.error(error, {
        domain: 'getFlatTourSchedule',
      });
    }
  };
}
